<template>
  <KCard h-icon="md-funnel" htitle="Visits">
    <div slot="content">
      <div class="date-frequency-selection text-right padding-b-20" v-if="visits.length && uniqueVisits.length">
        <RadioGroup v-model="selectedFrequency.frequency" type="button" @on-change="handleOnChangeFreqeuncy">
          <Radio label="1">Last 24 hours</Radio>
          <Radio label="2">Last 7 days</Radio>
          <Radio label="3">Last 30 days</Radio>
          <Radio label="4">Last 6 months</Radio>
          <Radio label="5">Last 12 months</Radio>
        </RadioGroup>
      </div>
      <VisitsGraph ref="VisitsGraph" :visits="visits" :uniqueVisits="uniqueVisits" :selectedFrequency="selectedFrequency"/>
    </div>
  </KCard>
</template>

<script>
import moment from 'moment'
import KCard from '@/components/ui/Card'
import VisitsGraph from '@/components/graphs/VisitsGraph'

export default {
  props: {
    visits: {
      type: Array,
      default: () => []
    },
    uniqueVisits: {
      type: Array,
      default: () => []
    }
  },

  components: {
    KCard,
    VisitsGraph
  },

  data () {
    return {
      selectedFrequency: {
        frequency: '2',
        dateFrom: moment().subtract(7, 'days').format('YYYY-MM-DD'),
        dateTo: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        mode: 'daily'
      }
    }
  },

  methods: {
    setFrequencyDates (val) {
      if (val === '1') { // Last 24 hours
        this.selectedFrequency.dateFrom = moment().startOf('day').format('YYYY-MM-DD')
        this.selectedFrequency.dateTo = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.selectedFrequency.mode = 'hourly'
      } else if (val === '3') { // Last 30 days
        this.selectedFrequency.dateFrom = moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.selectedFrequency.dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.selectedFrequency.mode = 'daily'
      } else if (val === '4') { // Last 6 months
        this.selectedFrequency.dateFrom = moment().subtract(6, 'months').set('date', 1).format('YYYY-MM-DD')
        this.selectedFrequency.dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.selectedFrequency.mode = 'daily'
      } else if (val === '5') { // Last 12 months
        this.selectedFrequency.dateFrom = moment().subtract(12, 'months').set('date', 1).format('YYYY-MM-DD')
        this.selectedFrequency.dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.selectedFrequency.mode = 'monthly'
      } else { // Last 7 days
        this.selectedFrequency.dateFrom = moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.selectedFrequency.dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD')
        this.selectedFrequency.mode = 'daily'
      }
    },

    handleOnChangeFreqeuncy (val) {
      this.setFrequencyDates(val)
      this.$refs.VisitsGraph.getChartData()
    }
  }
}
</script>
